export default ({ request }) => ({
  scmInfoImageListApi(data) {
    return request({
      url: '/digitalCenter/scmInfoImage/listPage',
      method: 'post',
      data,
    })
  },
  scmInfoImageVisitListApi(data) {
    return request({
      url: '/digitalCenter/scmInfoImage/list',
      method: 'post',
      data,
    })
  },
  scmInfoImageSaveApi(data) {
    return request({
      url: '/digitalCenter/scmInfoImage/save',
      method: 'post',
      data,
    })
  },
  scmInfoImageBatchAddApi(data) {
    return request({
      url: '/digitalCenter/scmInfoImage/imageBatchAdd',
      method: 'post',
      data,
    })
  },
  scmInfoUpdateImageDescApi(data) {
    return request({
      url: '/digitalCenter/scmInfoImage/updateImageDesc',
      method: 'post',
      data,
    })
  },
  scmInfoImageDelApi(data) {
    return request({
      url: '/digitalCenter/scmInfoImage/del',
      method: 'post',
      data,
    })
  },
})
